import React from 'react';
import { convertAed, formatNumber, useDisplayCurrency } from '../../utils/displayCurrency';
import { formatAed, formatAmount } from '../../utils/vat';
import { useShopLanguage } from './Money';

const SIZES = {
  sm: { amount: 'text-[15px]', currency: 'text-[10px]' },
  md: { amount: 'text-[18px]', currency: 'text-[11px]' },
  lg: { amount: 'text-[26px] md:text-[30px]', currency: 'text-[13px]' },
};

/**
 * Marketplace price (Temu "AED6.60"): the currency small and the amount big
 * and bold, always left to right. Screen readers hear "1,250 AED" once.
 * With a display currency picked it shows "≈ SAR 1,276.50" (display only);
 * `charge` keeps AED for an amount that is charged (the bag total).
 */
const PriceTag = ({ amount, size = 'md', sale = false, className = '', testId, charge = false }) => {
  const s = SIZES[size] || SIZES.md;
  const { cur } = useDisplayCurrency();
  const lang = useShopLanguage();
  const show = charge ? null : cur;
  const sym = show ? (lang === 'ar' ? show.symbol_ar : show.symbol_en) || show.code : 'AED';
  const num = show ? formatNumber(convertAed(amount, show), show.decimals ?? 2, lang) : formatAmount(amount);
  return (
    <span className={`price inline-flex items-baseline font-extrabold leading-none ${sale ? 'text-sale' : 'text-foreground'} ${className}`.trim()} data-testid={testId}>
      <span className="sr-only">{show ? `≈ ${num} ${show.code}, ${formatAed(amount)}` : formatAed(amount)}</span>
      <bdi dir="ltr" aria-hidden="true" className="inline-flex items-baseline" title={show ? formatAed(amount) : undefined}>
        <span className={`${s.currency} me-[1px] font-bold`}>{show ? `≈ ${sym}` : 'AED'}</span>
        <span className={`${s.amount} tracking-[-0.01em] tabular-nums`}>{num}</span>
      </bdi>
    </span>
  );
};

export default PriceTag;
